export default "__VITE_ASSET__CQle7uVt__"